var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeat10(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3489_6897)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.292 33.4371L30.0493 38.7172L38.1647 31.2745C38.4488 31.0141 38.6741 30.7049 38.8279 30.3646C38.9816 30.0241 39.0608 29.6595 39.0608 29.291V11.7106C39.0608 11.3422 38.9816 10.9775 38.8279 10.6371C38.6741 10.2968 38.4488 9.98757 38.1647 9.72712L30.0543 2.28906L24.2969 7.56916L36.2347 18.5174C36.5189 18.7781 36.7443 19.0875 36.8981 19.4281C37.0518 19.7688 37.1308 20.1338 37.1306 20.5024C37.1303 20.8711 37.0509 21.236 36.8967 21.5765C36.7426 21.9169 36.5168 22.2263 36.2322 22.4866L24.292 33.4371Z",
    fill: "#5ED3F0",
    stroke: "#5ED3F0",
    strokeWidth: 2.27,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.83594 33.4371L8.59329 38.7172L16.7087 31.2745C16.9927 31.0141 17.2181 30.7049 17.3719 30.3646C17.5256 30.0241 17.6048 29.6595 17.6048 29.291V11.7106C17.6048 11.3422 17.5256 10.9775 17.3719 10.6371C17.2181 10.2968 16.9927 9.98757 16.7087 9.72712L8.59829 2.28906L2.84094 7.56916L14.7787 18.5174C15.0629 18.7781 15.2883 19.0875 15.4421 19.4281C15.5957 19.7688 15.6748 20.1338 15.6746 20.5024C15.6743 20.8711 15.5948 21.236 15.4407 21.5765C15.2866 21.9169 15.0608 22.2263 14.7762 22.4866L2.83594 33.4371Z",
    fill: "#5ED3F0",
    stroke: "#5ED3F0",
    strokeWidth: 2.27,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3489_6897"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 41,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeat10);
export default __webpack_public_path__ + "static/media/feat-10.a6c2bfc7b90cb296fb7291f218a0926e.svg";
export { ForwardRef as ReactComponent };